export const ACCOUNT_PAGE_KEY = 'account';

export const GET_USER_INFO = 'account/GET_USER_INFO';
export const GET_USER_INFO_SUCCESS = 'account/GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILURE = 'account/GET_USER_INFO_FAILURE';

export const LOAD_USER_ORDERS = 'account/LOAD_USER_ORDERS';
export const LOAD_USER_ORDERS_SUCCESS = 'account/LOAD_USER_ORDERS_SUCCESS';
export const LOAD_USER_ORDERS_FAILURE = 'account/LOAD_USER_ORDERS_FAILURE';
